import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  PLUGIN_DELETE_PERMISSION_BEGIN,
  PLUGIN_DELETE_PERMISSION_SUCCESS,
  PLUGIN_DELETE_PERMISSION_FAILURE,
  PLUGIN_DELETE_PERMISSION_DISMISS_ERROR,
} from './constants';
import axios from 'axios';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function deletePermission(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: PLUGIN_DELETE_PERMISSION_BEGIN,
    });
    const { projectId } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(`${process.env.REACT_APP_BUILDER_ENGINE}permissions/get`, header);
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: PLUGIN_DELETE_PERMISSION_SUCCESS,
              data: res.data,
            });
            resolve(res.data);
          } else {
            const errMsg = getErrorMessageFromResponse(res);
            dispatch({
              type: PLUGIN_DELETE_PERMISSION_FAILURE,
              data: { error: 'Failed' },
            });
            resolve('Failed');
          }
        },
        (err) => {
          dispatch({
            type: PLUGIN_DELETE_PERMISSION_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissDeletePermissionError() {
  return {
    type: PLUGIN_DELETE_PERMISSION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PLUGIN_DELETE_PERMISSION_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        deletePermissionPending: true,
        deletePermissionError: null,
      };

    case PLUGIN_DELETE_PERMISSION_SUCCESS:
      // The request is success
      return {
        ...state,
        deletePermissionPending: false,
        deletePermissionError: null,
        permissionFlags: action.data,
      };

    case PLUGIN_DELETE_PERMISSION_FAILURE:
      // The request is failed
      return {
        ...state,
        deletePermissionPending: false,
        deletePermissionError: action.data.error,
      };

    case PLUGIN_DELETE_PERMISSION_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        deletePermissionError: null,
      };

    default:
      return state;
  }
}
